import React from "react";

export default () => {


    return (
        <table style={{ width: '100%', height: '48px', borderStyle: 'solid', borderWidth: '0px', borderCollapse: 'collapse' }}>
            <tr>
                <td style={{ width: '80px', textAlign: 'left', fontSize: '16px', fontFamily: 'Righteous',cursor:'pointer' }}  onClick={()=>{ document.location.href='/kr' }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1DAY1JOB
                </td>
                <td style={{ textAlign: 'right', fontSize: '11px' }}>
                    &nbsp;&nbsp;
                    {/*<span style={{ color: '#222222' }}>사업자회원</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ color: '#888888', cursor:'pointer' }}  onClick={()=>{ document.location.href='/kr/corp/login' }} >로그인</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ color: '#888888', cursor:'pointer' }} onClick={()=>{ document.location.href='/kr/corp/signup' }} >가입</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*/}
                </td>
            </tr>
        </table>
    );

}